export const CREATE_NEW_PROFILES_MODAL_MANUAL_IDENTIFIER = 'createNewProfilesModal/CREATE_NEW_PROFILES_MODAL_MANUAL_IDENTIFIER';
export const CREATE_NEW_PROFILES_MODAL_TEMPLATE_IDENTIFIER = 'createNewProfilesModal/CREATE_NEW_PROFILES_MODAL_TEMPLATE_IDENTIFIER';

export const XLSX_TEMPLATE_URL = '/static/files/upload-lightweight-creators-template.xlsx';

export const ENTITIES_PER_PAGE = 50;
